(()=>{if(window.TurtlesonWardrobeLogic){window.TurtlesonWardrobeLogic.initializeAll();return;}let activeCurrency="USD";
const catalog = {
  "snapshotDate": "2026-10-08",
  "items": {
    "eucalyptus-heather": {
      "id": "eucalyptus-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Eucalyptus Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-5576705.jpg?v=1786408573",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-5576705.jpg?v=1786408573",
      "url": "/products/woolen-fleece-quarter-zip?variant=59756612190494",
      "variants": [
        {
          "id": "59756612190494",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-G0202-S"
        },
        {
          "id": "59756612223262",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-G0202-M"
        },
        {
          "id": "59756612256030",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-G0202-L"
        },
        {
          "id": "59756612288798",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-G0202-XL"
        },
        {
          "id": "59756612321566",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-G0202-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "avery-ls-polo--antique-white-heather": {
      "id": "avery-ls-polo--antique-white-heather",
      "productId": "avery-ls-polo",
      "handle": "avery-ls-polo",
      "title": "Avery Long Sleeve Performance Polo",
      "color": "Antique White Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/avery-long-sleeve-performance-polo-4630072.jpg?v=1786408574",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/avery-long-sleeve-performance-polo-4630072.jpg?v=1786408574",
      "url": "/products/avery-ls-polo?variant=59756612583710",
      "variants": [
        {
          "id": "59756612550942",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 16500,
          "sku": "MTK0295-W0006-S"
        },
        {
          "id": "59756612583710",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-W0006-M"
        },
        {
          "id": "59756612616478",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-W0006-L"
        },
        {
          "id": "59756612649246",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-W0006-XL"
        },
        {
          "id": "59756612682014",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-W0006-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-pant--anchor": {
      "id": "tide-to-tee-pant--anchor",
      "productId": "tide-to-tee-pant",
      "handle": "tide-to-tee-pant",
      "title": "Tide to Tee Pant",
      "color": "Anchor",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-1277832.jpg?v=1776284602",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-1277832.jpg?v=1776284602",
      "url": "/products/tide-to-tee-pant?variant=50573800735006",
      "variants": [
        {
          "id": "50573800735006",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-30"
        },
        {
          "id": "50573800767774",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-32"
        },
        {
          "id": "50573800800542",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-33"
        },
        {
          "id": "50573800833310",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-34"
        },
        {
          "id": "50573800866078",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-35"
        },
        {
          "id": "50573800898846",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-36"
        },
        {
          "id": "50573800931614",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-38"
        },
        {
          "id": "50573800964382",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-40"
        },
        {
          "id": "50573800997150",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "eucalyptus-heather-casual-shoes": {
      "id": "eucalyptus-heather-casual-shoes",
      "title": "Ivory spikeless golf shoes",
      "color": "Ivory with tan trim",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "rockdale-brushed-twill-sport-shirt--luxe-blue": {
      "id": "rockdale-brushed-twill-sport-shirt--luxe-blue",
      "productId": "rockdale-brushed-twill-sport-shirt",
      "handle": "rockdale-brushed-twill-sport-shirt",
      "title": "Rockdale Brushed Twill Sport Shirt",
      "color": "LUXE BLUE",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/rockdale-brushed-twill-sport-shirt-6930277.jpg?v=1786405226",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/rockdale-brushed-twill-sport-shirt-6930277.jpg?v=1786405226",
      "url": "/products/rockdale-brushed-twill-sport-shirt?variant=59756553535774",
      "variants": [
        {
          "id": "59756553535774",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17000,
          "sku": "MTW0167-LUXB-S"
        },
        {
          "id": "59756553568542",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17000,
          "sku": "MTW0167-LUXB-M"
        },
        {
          "id": "59756553601310",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17000,
          "sku": "MTW0167-LUXB-L"
        },
        {
          "id": "59756553634078",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17000,
          "sku": "MTW0167-LUXB-XL"
        },
        {
          "id": "59756553666846",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17000,
          "sku": "MTW0167-LUXB-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--stone": {
      "id": "mbp0019-arthur-corduroy-5-pocket--stone",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Stone",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087115198750",
      "variants": [
        {
          "id": "49087115198750",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-30"
        },
        {
          "id": "49087115231518",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-32"
        },
        {
          "id": "49087115264286",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-33"
        },
        {
          "id": "49087115297054",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-34"
        },
        {
          "id": "49087115329822",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-35"
        },
        {
          "id": "49087115362590",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-36"
        },
        {
          "id": "49087115395358",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-38"
        },
        {
          "id": "49087115428126",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-40"
        },
        {
          "id": "49087115460894",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "eucalyptus-heather-shirt-shoes": {
      "id": "eucalyptus-heather-shirt-shoes",
      "title": "Dark brown leather penny loafers",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "stirling-sport-zip-polo--luxe-blue-heather": {
      "id": "stirling-sport-zip-polo--luxe-blue-heather",
      "productId": "stirling-sport-zip-polo",
      "handle": "stirling-sport-zip-polo",
      "title": "Stirling Sport Zip Polo",
      "color": "Luxe Blue Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/stirling-sport-zip-polo-6571340.jpg?v=1776284959",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/stirling-sport-zip-polo-6571340.jpg?v=1776284959",
      "url": "/products/stirling-sport-zip-polo?variant=50078912872734",
      "variants": [
        {
          "id": "50078912872734",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-LUHE-S"
        },
        {
          "id": "50078912905502",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 16000,
          "sku": "MTK0250-LUHE-M"
        },
        {
          "id": "50078912938270",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-LUHE-L"
        },
        {
          "id": "50078912971038",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-LUHE-XL"
        },
        {
          "id": "50078913003806",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-LUHE-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--admiral": {
      "id": "mbp0019-arthur-corduroy-5-pocket--admiral",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Admiral",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-7188387.jpg?v=1776285555",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-7188387.jpg?v=1776285555",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087114641694",
      "variants": [
        {
          "id": "49087114641694",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-30"
        },
        {
          "id": "49087114674462",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-32"
        },
        {
          "id": "49087114707230",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-33"
        },
        {
          "id": "49087114739998",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-34"
        },
        {
          "id": "49087114772766",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-35"
        },
        {
          "id": "49087114805534",
          "options": {
            "Size": "36"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-36"
        },
        {
          "id": "49087114838302",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-38"
        },
        {
          "id": "49087114871070",
          "options": {
            "Size": "40"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-40"
        },
        {
          "id": "49087114903838",
          "options": {
            "Size": "42"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MBP0019-B0051-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "eucalyptus-heather-jacket-shoes": {
      "id": "eucalyptus-heather-jacket-shoes",
      "title": "Snuff suede Chelsea boots",
      "color": "Snuff brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "blue-steel-heather": {
      "id": "blue-steel-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Blue Steel Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-5352073.jpg?v=1786408573",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-5352073.jpg?v=1786408573",
      "url": "/products/woolen-fleece-quarter-zip?variant=59756612026654",
      "variants": [
        {
          "id": "59756612026654",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0669-S"
        },
        {
          "id": "59756612059422",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0669-M"
        },
        {
          "id": "59756612092190",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0669-L"
        },
        {
          "id": "59756612124958",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0669-XL"
        },
        {
          "id": "59756612157726",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0669-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "atlantic-long-sleeve-pocket-tee--white": {
      "id": "atlantic-long-sleeve-pocket-tee--white",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "White",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-8314864.jpg?v=1776284534",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-8314864.jpg?v=1776284534",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789564023070",
      "variants": [
        {
          "id": "50789564023070",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-S"
        },
        {
          "id": "50789564055838",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-M"
        },
        {
          "id": "50789564088606",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-L"
        },
        {
          "id": "50789564121374",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-XL"
        },
        {
          "id": "50789564154142",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-WHIT-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "blue-steel-heather-casual-jeans": {
      "id": "blue-steel-heather-casual-jeans",
      "title": "Your mid-blue straight-leg jeans",
      "color": "Mid-blue",
      "ownership": "closet",
      "isDenim": true,
      "fromYourCloset": true,
      "icon": "denim",
      "active": true
    },
    "blue-steel-heather-casual-shoes": {
      "id": "blue-steel-heather-casual-shoes",
      "title": "Sand suede desert boots",
      "color": "Sand",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "nells-button-front--anchor-blue-steel": {
      "id": "nells-button-front--anchor-blue-steel",
      "productId": "nells-button-front",
      "handle": "nells-button-front",
      "title": "Nells Jacquard Button Front",
      "color": "ANCHOR / BLUE STEEL",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/nells-jacquard-button-front-5613750.jpg?v=1786405221",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/nells-jacquard-button-front-5613750.jpg?v=1786405221",
      "url": "/products/nells-button-front?variant=59756566479134",
      "variants": [
        {
          "id": "59756566479134",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-S"
        },
        {
          "id": "59756566511902",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-M"
        },
        {
          "id": "59756566544670",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-L"
        },
        {
          "id": "59756566577438",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-XL"
        },
        {
          "id": "59756566610206",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--taupe": {
      "id": "ridge-sateen-pant--taupe",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Taupe",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5695021.png?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5695021.png?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756545671454",
      "variants": [
        {
          "id": "59756545638686",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-30"
        },
        {
          "id": "59756545671454",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-30"
        },
        {
          "id": "59756545704222",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-30"
        },
        {
          "id": "59756545736990",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-32"
        },
        {
          "id": "59756545769758",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-32"
        },
        {
          "id": "59756545802526",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-32"
        },
        {
          "id": "59756545835294",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-33"
        },
        {
          "id": "59756545868062",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-33"
        },
        {
          "id": "59756545900830",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-33"
        },
        {
          "id": "59756545933598",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-34"
        },
        {
          "id": "59756545966366",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-34"
        },
        {
          "id": "59756545999134",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-34"
        },
        {
          "id": "59756546031902",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-35"
        },
        {
          "id": "59756546064670",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-35"
        },
        {
          "id": "59756546097438",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-35"
        },
        {
          "id": "59756546130206",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-36"
        },
        {
          "id": "59756546162974",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-36"
        },
        {
          "id": "59756546195742",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-36"
        },
        {
          "id": "59756546228510",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-38"
        },
        {
          "id": "59756546261278",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-38"
        },
        {
          "id": "59756546294046",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-38"
        },
        {
          "id": "59756546326814",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-40"
        },
        {
          "id": "59756546359582",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-40"
        },
        {
          "id": "59756546392350",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-40"
        },
        {
          "id": "59756546425118",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-30-42"
        },
        {
          "id": "59756546457886",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-32-42"
        },
        {
          "id": "59756546490654",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-N0027-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "blue-steel-heather-shirt-shoes": {
      "id": "blue-steel-heather-shirt-shoes",
      "title": "Black leather loafers",
      "color": "Black",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "leni-2-button-polo--persimmon": {
      "id": "leni-2-button-polo--persimmon",
      "productId": "leni-2-button-polo",
      "handle": "leni-2-button-polo",
      "title": "Leni Two-Button Polo",
      "color": "PERSIMMON",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/leni-two-button-polo-4060784.jpg?v=1786405218",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/leni-two-button-polo-4060784.jpg?v=1786405218",
      "url": "/products/leni-2-button-polo?variant=59756573131038",
      "variants": [
        {
          "id": "59756573131038",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-O0092-S"
        },
        {
          "id": "59756573163806",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-O0092-M"
        },
        {
          "id": "59756573196574",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-O0092-L"
        },
        {
          "id": "59756573229342",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-O0092-XL"
        },
        {
          "id": "59756573262110",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-O0092-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "bristol-brushed-twill-hybrid-5-pocket--navy": {
      "id": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "productId": "bristol-brushed-twill-hybrid-5-pocket",
      "handle": "bristol-brushed-twill-hybrid-5-pocket",
      "title": "Bristol Twill Hybrid 5-Pocket Pant",
      "color": "Navy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "url": "/products/bristol-brushed-twill-hybrid-5-pocket?variant=12551735083096",
      "variants": [
        {
          "id": "12551735083096",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-32"
        },
        {
          "id": "12551735115864",
          "options": {
            "Size": "33"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-33"
        },
        {
          "id": "12551735148632",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-34"
        },
        {
          "id": "12551735181400",
          "options": {
            "Size": "35"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-35"
        },
        {
          "id": "12551735214168",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-36"
        },
        {
          "id": "12551735246936",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-38"
        },
        {
          "id": "12551735279704",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-40"
        },
        {
          "id": "12551735312472",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "blue-steel-heather-jacket-shoes": {
      "id": "blue-steel-heather-jacket-shoes",
      "title": "Dark brown suede Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "admiral-heather": {
      "id": "admiral-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Admiral Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-7999717.jpg?v=1786408573",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/woolen-fleece-quarter-zip-7999717.jpg?v=1786408573",
      "url": "/products/woolen-fleece-quarter-zip?variant=50078930764062",
      "variants": [
        {
          "id": "50078930764062",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0082-S"
        },
        {
          "id": "50078930796830",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0082-M"
        },
        {
          "id": "50078930829598",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0082-L"
        },
        {
          "id": "50078930862366",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0082-XL"
        },
        {
          "id": "50078930895134",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0082-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "avery-ls-polo--stillwater-heather": {
      "id": "avery-ls-polo--stillwater-heather",
      "productId": "avery-ls-polo",
      "handle": "avery-ls-polo",
      "title": "Avery Long Sleeve Performance Polo",
      "color": "Stillwater Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0295_B0279.jpg?v=1786376960",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0295_B0279.jpg?v=1786376960",
      "url": "/products/avery-ls-polo?variant=50078914281758",
      "variants": [
        {
          "id": "50078914281758",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-B0279-S"
        },
        {
          "id": "50078914314526",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-B0279-M"
        },
        {
          "id": "50078914347294",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-B0279-L"
        },
        {
          "id": "50078914380062",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-B0279-XL"
        },
        {
          "id": "50078914412830",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-B0279-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-pant--shadow": {
      "id": "tide-to-tee-pant--shadow",
      "productId": "tide-to-tee-pant",
      "handle": "tide-to-tee-pant",
      "title": "Tide to Tee Pant",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-9099536.jpg?v=1776284602",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-9099536.jpg?v=1776284602",
      "url": "/products/tide-to-tee-pant?variant=50573800440094",
      "variants": [
        {
          "id": "50573800440094",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-30"
        },
        {
          "id": "50573800472862",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-32"
        },
        {
          "id": "50573800505630",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-33"
        },
        {
          "id": "50573800538398",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-34"
        },
        {
          "id": "50573800571166",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-35"
        },
        {
          "id": "50573800603934",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-36"
        },
        {
          "id": "50573800636702",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-38"
        },
        {
          "id": "50573800669470",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-40"
        },
        {
          "id": "50573800702238",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-E0016-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "admiral-heather-casual-shoes": {
      "id": "admiral-heather-casual-shoes",
      "title": "White leather spikeless golf shoes",
      "color": "White with gray trim",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "highland-brushed-twill--luxe-blue-clementine": {
      "id": "highland-brushed-twill--luxe-blue-clementine",
      "productId": "highland-brushed-twill",
      "handle": "highland-brushed-twill",
      "title": "Highland Brushed Twill Sport Shirt",
      "color": "Luxe Blue/ Clementine",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTW0359_LUCL_3.jpg?v=1784572052",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTW0359_LUCL_3.jpg?v=1784572052",
      "url": "/products/highland-brushed-twill?variant=50078956978462",
      "variants": [
        {
          "id": "50078956978462",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0359-LUCL-S"
        },
        {
          "id": "50078957011230",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0359-LUCL-M"
        },
        {
          "id": "50078957043998",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0359-LUCL-L"
        },
        {
          "id": "50078957076766",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0359-LUCL-XL"
        },
        {
          "id": "50078957109534",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0359-LUCL-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "admiral-heather-shirt-shoes": {
      "id": "admiral-heather-shirt-shoes",
      "title": "Tobacco suede loafers",
      "color": "Tobacco brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "bruce-polo--mulled-berry": {
      "id": "bruce-polo--mulled-berry",
      "productId": "bruce-polo",
      "handle": "bruce-polo",
      "title": "Bruce Polo",
      "color": "MULLED BERRY",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bruce-polo-8543431.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bruce-polo-8543431.jpg?v=1786405220",
      "url": "/products/bruce-polo?variant=59756572147998",
      "variants": [
        {
          "id": "59756572147998",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-P0149-S"
        },
        {
          "id": "59756572180766",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-P0149-M"
        },
        {
          "id": "59756572213534",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-P0149-L"
        },
        {
          "id": "59756572246302",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-P0149-XL"
        },
        {
          "id": "59756572279070",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-P0149-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "admiral-heather-jacket-shoes": {
      "id": "admiral-heather-jacket-shoes",
      "title": "Dark brown suede Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "loche-heather": {
      "id": "loche-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Loche Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_B0280.jpg?v=1786376947",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_B0280.jpg?v=1786376947",
      "url": "/products/woolen-fleece-quarter-zip?variant=50078931091742",
      "variants": [
        {
          "id": "50078931091742",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0280-S"
        },
        {
          "id": "50078931124510",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0280-M"
        },
        {
          "id": "50078931157278",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0280-L"
        },
        {
          "id": "50078931190046",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0280-XL"
        },
        {
          "id": "50078931222814",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0280-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--khaki": {
      "id": "ridge-sateen-pant--khaki",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Khaki",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756546556190",
      "variants": [
        {
          "id": "59756546523422",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-30"
        },
        {
          "id": "59756546556190",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-30"
        },
        {
          "id": "59756546588958",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-30"
        },
        {
          "id": "59756546621726",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-32"
        },
        {
          "id": "59756546654494",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-32"
        },
        {
          "id": "59756546687262",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-32"
        },
        {
          "id": "59756546720030",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-33"
        },
        {
          "id": "59756546752798",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-33"
        },
        {
          "id": "59756546785566",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-33"
        },
        {
          "id": "59756546818334",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-34"
        },
        {
          "id": "59756546851102",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-34"
        },
        {
          "id": "59756546883870",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-34"
        },
        {
          "id": "59756546916638",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-35"
        },
        {
          "id": "59756546949406",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-35"
        },
        {
          "id": "59756546982174",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-35"
        },
        {
          "id": "59756547014942",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-36"
        },
        {
          "id": "59756547047710",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-36"
        },
        {
          "id": "59756547080478",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-36"
        },
        {
          "id": "59756547113246",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-38"
        },
        {
          "id": "59756547146014",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-38"
        },
        {
          "id": "59756547178782",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-38"
        },
        {
          "id": "59756547211550",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-40"
        },
        {
          "id": "59756547244318",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-40"
        },
        {
          "id": "59756547277086",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-40"
        },
        {
          "id": "59756547309854",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-42"
        },
        {
          "id": "59756547342622",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-42"
        },
        {
          "id": "59756547375390",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "loche-heather-casual-shoes": {
      "id": "loche-heather-casual-shoes",
      "title": "Sand suede desert boots",
      "color": "Sand",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "dario-sportshirt--luxe-blue-navy": {
      "id": "dario-sportshirt--luxe-blue-navy",
      "productId": "dario-sportshirt",
      "handle": "dario-sportshirt",
      "title": "Dario Cotton Sport Shirt",
      "color": "Luxe Blue / Navy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/dario-cotton-sport-shirt-1400082.jpg?v=1784635688",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/dario-cotton-sport-shirt-1400082.jpg?v=1784635688",
      "url": "/products/dario-sportshirt?variant=50078953734430",
      "variants": [
        {
          "id": "50078953734430",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0352-LUXN-S"
        },
        {
          "id": "50078953767198",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0352-LUXN-M"
        },
        {
          "id": "50078953799966",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0352-LUXN-L"
        },
        {
          "id": "50078953832734",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0352-LUXN-XL"
        },
        {
          "id": "50078953865502",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0352-LUXN-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--admiral": {
      "id": "ridge-sateen-pant--admiral",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Admiral",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "url": "/products/ridge-sateen-pant?variant=59756543901982",
      "variants": [
        {
          "id": "59756543869214",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-30"
        },
        {
          "id": "59756543901982",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-30"
        },
        {
          "id": "59756543934750",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-30"
        },
        {
          "id": "59756543967518",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-32"
        },
        {
          "id": "59756544000286",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-32"
        },
        {
          "id": "59756544033054",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-32"
        },
        {
          "id": "59756544065822",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-33"
        },
        {
          "id": "59756544098590",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-33"
        },
        {
          "id": "59756544131358",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-33"
        },
        {
          "id": "59756544164126",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-34"
        },
        {
          "id": "59756544196894",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-34"
        },
        {
          "id": "59756544229662",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-34"
        },
        {
          "id": "59756544262430",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-35"
        },
        {
          "id": "59756544295198",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-35"
        },
        {
          "id": "59756544327966",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-35"
        },
        {
          "id": "59756544360734",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-36"
        },
        {
          "id": "59756544393502",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-36"
        },
        {
          "id": "59756544426270",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-36"
        },
        {
          "id": "59756544459038",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-38"
        },
        {
          "id": "59756544491806",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-38"
        },
        {
          "id": "59756544524574",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-38"
        },
        {
          "id": "59756544557342",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-40"
        },
        {
          "id": "59756544590110",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-40"
        },
        {
          "id": "59756544622878",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-40"
        },
        {
          "id": "59756544655646",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-42"
        },
        {
          "id": "59756544688414",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-42"
        },
        {
          "id": "59756544721182",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "loche-heather-shirt-shoes": {
      "id": "loche-heather-shirt-shoes",
      "title": "Dark brown leather penny loafers",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "leni-2-button-polo--sage": {
      "id": "leni-2-button-polo--sage",
      "productId": "leni-2-button-polo",
      "handle": "leni-2-button-polo",
      "title": "Leni Two-Button Polo",
      "color": "SAGE",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/leni-two-button-polo-8561116.jpg?v=1786405217",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/leni-two-button-polo-8561116.jpg?v=1786405217",
      "url": "/products/leni-2-button-polo?variant=59756572803358",
      "variants": [
        {
          "id": "59756572803358",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-G0198-S"
        },
        {
          "id": "59756572836126",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-G0198-M"
        },
        {
          "id": "59756572868894",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-G0198-L"
        },
        {
          "id": "59756572901662",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-G0198-XL"
        },
        {
          "id": "59756572934430",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0692-G0198-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--khaki": {
      "id": "mbp0019-arthur-corduroy-5-pocket--khaki",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Khaki",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-3335079.jpg?v=1776285557",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-3335079.jpg?v=1776285557",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087114936606",
      "variants": [
        {
          "id": "49087114936606",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-30"
        },
        {
          "id": "49087114969374",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-32"
        },
        {
          "id": "49087115002142",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-33"
        },
        {
          "id": "49087115034910",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-34"
        },
        {
          "id": "49087115067678",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-35"
        },
        {
          "id": "49087115100446",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-36"
        },
        {
          "id": "49087115133214",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-38"
        },
        {
          "id": "49087115165982",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "loche-heather-jacket-shoes": {
      "id": "loche-heather-jacket-shoes",
      "title": "Dark brown suede Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "shadow-heather": {
      "id": "shadow-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Shadow Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_E0027.jpg?v=1786376946",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_E0027.jpg?v=1786376946",
      "url": "/products/woolen-fleece-quarter-zip?variant=50078931255582",
      "variants": [
        {
          "id": "50078931255582",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-E0027-S"
        },
        {
          "id": "50078931288350",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-E0027-M"
        },
        {
          "id": "50078931321118",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 18500,
          "sku": "MTL0251-E0027-L"
        },
        {
          "id": "50078931353886",
          "options": {
            "Size": "XL"
          },
          "available": false,
          "priceCents": 18500,
          "sku": "MTL0251-E0027-XL"
        },
        {
          "id": "50078931386654",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-E0027-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "stateline-5-pocket-pant-stone--stone": {
      "id": "stateline-5-pocket-pant-stone--stone",
      "productId": "stateline-5-pocket-pant-stone",
      "handle": "stateline-5-pocket-pant-stone",
      "title": "Stateline 5-Pocket Pant (Stone)",
      "color": "Stone",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/stateline-5-pocket-pant-stone-3482667.jpg?v=1776285551",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/stateline-5-pocket-pant-stone-3482667.jpg?v=1776285551",
      "url": "/products/stateline-5-pocket-pant-stone?variant=48471454384414",
      "variants": [
        {
          "id": "48471454384414",
          "options": {
            "Waist": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-30"
        },
        {
          "id": "48471454449950",
          "options": {
            "Waist": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-32"
        },
        {
          "id": "48471454515486",
          "options": {
            "Waist": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-33"
        },
        {
          "id": "48471454581022",
          "options": {
            "Waist": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-34"
        },
        {
          "id": "48471454646558",
          "options": {
            "Waist": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-35"
        },
        {
          "id": "48471454712094",
          "options": {
            "Waist": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-36"
        },
        {
          "id": "48471454777630",
          "options": {
            "Waist": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-38"
        },
        {
          "id": "48471454843166",
          "options": {
            "Waist": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-40"
        },
        {
          "id": "48471454908702",
          "options": {
            "Waist": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MS24P04-STON-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-heather-casual-shoes": {
      "id": "shadow-heather-casual-shoes",
      "title": "Light gray suede sneakers",
      "color": "Light gray",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "olaf-brushed-twill--syrah": {
      "id": "olaf-brushed-twill--syrah",
      "productId": "olaf-brushed-twill",
      "handle": "olaf-brushed-twill",
      "title": "Olaf Brushed Twill Sport Shirt",
      "color": "Syrah",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/olaf-brushed-twill-sport-shirt-6301380.jpg?v=1784635688",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/olaf-brushed-twill-sport-shirt-6301380.jpg?v=1784635688",
      "url": "/products/olaf-brushed-twill?variant=50078958059806",
      "variants": [
        {
          "id": "50078958059806",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-R0039-S"
        },
        {
          "id": "50078958092574",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-R0039-M"
        },
        {
          "id": "50078958125342",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-R0039-L"
        },
        {
          "id": "50078958158110",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-R0039-XL"
        },
        {
          "id": "50078958190878",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTW0360-R0039-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-heather-shirt-shoes": {
      "id": "shadow-heather-shirt-shoes",
      "title": "Oxblood leather loafers",
      "color": "Oxblood",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "kit-polo--wisteria": {
      "id": "kit-polo--wisteria",
      "productId": "kit-polo",
      "handle": "kit-polo",
      "title": "Kit Polo",
      "color": "WISTERIA",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/kit-polo-4763921.jpg?v=1786405218",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/kit-polo-4763921.jpg?v=1786405218",
      "url": "/products/kit-polo?variant=59756572475678",
      "variants": [
        {
          "id": "59756572475678",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0693-P0143-S"
        },
        {
          "id": "59756572508446",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0693-P0143-M"
        },
        {
          "id": "59756572541214",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0693-P0143-L"
        },
        {
          "id": "59756572573982",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0693-P0143-XL"
        },
        {
          "id": "59756572606750",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0693-P0143-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-heather-jacket-shoes": {
      "id": "shadow-heather-jacket-shoes",
      "title": "Black leather Chelsea boots",
      "color": "Black",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "stillwater-heather": {
      "id": "stillwater-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Stillwater Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_B0279.jpg?v=1786376946",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_B0279.jpg?v=1786376946",
      "url": "/products/woolen-fleece-quarter-zip?variant=50078930927902",
      "variants": [
        {
          "id": "50078930927902",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0279-S"
        },
        {
          "id": "50078930960670",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0279-M"
        },
        {
          "id": "50078930993438",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0279-L"
        },
        {
          "id": "50078931026206",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0279-XL"
        },
        {
          "id": "50078931058974",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-B0279-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "avery-ls-polo--thistle-heather": {
      "id": "avery-ls-polo--thistle-heather",
      "productId": "avery-ls-polo",
      "handle": "avery-ls-polo",
      "title": "Avery Long Sleeve Performance Polo",
      "color": "Thistle Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0295_P0056.jpg?v=1786376960",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0295_P0056.jpg?v=1786376960",
      "url": "/products/avery-ls-polo?variant=50078914773278",
      "variants": [
        {
          "id": "50078914773278",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-P0056-S"
        },
        {
          "id": "50078914806046",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-P0056-M"
        },
        {
          "id": "50078914838814",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-P0056-L"
        },
        {
          "id": "50078914871582",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-P0056-XL"
        },
        {
          "id": "50078914904350",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16500,
          "sku": "MTK0295-P0056-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "stillwater-heather-casual-shoes": {
      "id": "stillwater-heather-casual-shoes",
      "title": "Ivory spikeless golf shoes",
      "color": "Ivory with tan trim",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "market-sportshirt--white-shamrock": {
      "id": "market-sportshirt--white-shamrock",
      "productId": "market-sportshirt",
      "handle": "market-sportshirt",
      "title": "Market Cotton Sport Shirt",
      "color": "White/Shamrock",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-5490492.jpg?v=1784635688",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-5490492.jpg?v=1784635688",
      "url": "/products/market-sportshirt?variant=50078951604510",
      "variants": [
        {
          "id": "50078951604510",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-S"
        },
        {
          "id": "50078951637278",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-M"
        },
        {
          "id": "50078951670046",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-L"
        },
        {
          "id": "50078951702814",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-XL"
        },
        {
          "id": "50078951735582",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "stillwater-heather-shirt-shoes": {
      "id": "stillwater-heather-shirt-shoes",
      "title": "Tobacco suede loafers",
      "color": "Tobacco brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "bruce-polo--sage": {
      "id": "bruce-polo--sage",
      "productId": "bruce-polo",
      "handle": "bruce-polo",
      "title": "Bruce Polo",
      "color": "SAGE",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bruce-polo-1698306.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bruce-polo-1698306.jpg?v=1786405220",
      "url": "/products/bruce-polo?variant=59756571656478",
      "variants": [
        {
          "id": "59756571656478",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-G0198-S"
        },
        {
          "id": "59756571689246",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-G0198-M"
        },
        {
          "id": "59756571722014",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-G0198-L"
        },
        {
          "id": "59756571754782",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-G0198-XL"
        },
        {
          "id": "59756571787550",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0694-G0198-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "stillwater-heather-jacket-shoes": {
      "id": "stillwater-heather-jacket-shoes",
      "title": "Snuff suede Chelsea boots",
      "color": "Snuff brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "black-heather": {
      "id": "black-heather",
      "productId": "woolen-fleece-quarter-zip",
      "handle": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "color": "Black Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_A0012.jpg?v=1786376946",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTL0251_A0012.jpg?v=1786376946",
      "url": "/products/woolen-fleece-quarter-zip?variant=50078930600222",
      "variants": [
        {
          "id": "50078930600222",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-A0012-S"
        },
        {
          "id": "50078930632990",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18500,
          "sku": "MTL0251-A0012-M"
        },
        {
          "id": "50078930665758",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 18500,
          "sku": "MTL0251-A0012-L"
        },
        {
          "id": "50078930698526",
          "options": {
            "Size": "XL"
          },
          "available": false,
          "priceCents": 18500,
          "sku": "MTL0251-A0012-XL"
        },
        {
          "id": "50078930731294",
          "options": {
            "Size": "2XL"
          },
          "available": false,
          "priceCents": 18500,
          "sku": "MTL0251-A0012-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-heather-casual-jeans": {
      "id": "black-heather-casual-jeans",
      "title": "Your washed black straight-leg jeans",
      "color": "Washed black",
      "ownership": "closet",
      "isDenim": true,
      "fromYourCloset": true,
      "icon": "denim",
      "active": true
    },
    "black-heather-casual-shoes": {
      "id": "black-heather-casual-shoes",
      "title": "White leather sneakers",
      "color": "White",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "gunnar-sportshirt--stillwater": {
      "id": "gunnar-sportshirt--stillwater",
      "productId": "gunnar-sportshirt",
      "handle": "gunnar-sportshirt",
      "title": "Gunnar Cotton Sport Shirt",
      "color": "Stillwater",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-5947289.jpg?v=1784635690",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-5947289.jpg?v=1784635690",
      "url": "/products/gunnar-sportshirt?variant=50078948589854",
      "variants": [
        {
          "id": "50078948589854",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-S"
        },
        {
          "id": "50078948622622",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-M"
        },
        {
          "id": "50078948655390",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-L"
        },
        {
          "id": "50078948688158",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-XL"
        },
        {
          "id": "50078948720926",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-B0275-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--blue-steel": {
      "id": "ridge-sateen-pant--blue-steel",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Blue Steel",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7345844.jpg?v=1786405286",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7345844.jpg?v=1786405286",
      "url": "/products/ridge-sateen-pant?variant=59756543017246",
      "variants": [
        {
          "id": "59756542984478",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-30"
        },
        {
          "id": "59756543017246",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-30"
        },
        {
          "id": "59756543050014",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-30"
        },
        {
          "id": "59756543082782",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-32"
        },
        {
          "id": "59756543115550",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-32"
        },
        {
          "id": "59756543148318",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-32"
        },
        {
          "id": "59756543181086",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-33"
        },
        {
          "id": "59756543213854",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-33"
        },
        {
          "id": "59756543246622",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-33"
        },
        {
          "id": "59756543279390",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-34"
        },
        {
          "id": "59756543312158",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-34"
        },
        {
          "id": "59756543344926",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-34"
        },
        {
          "id": "59756543377694",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-35"
        },
        {
          "id": "59756543410462",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-35"
        },
        {
          "id": "59756543443230",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-35"
        },
        {
          "id": "59756543475998",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-36"
        },
        {
          "id": "59756543508766",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-36"
        },
        {
          "id": "59756543541534",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-36"
        },
        {
          "id": "59756543574302",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-38"
        },
        {
          "id": "59756543607070",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-38"
        },
        {
          "id": "59756543639838",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-38"
        },
        {
          "id": "59756543672606",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-40"
        },
        {
          "id": "59756543705374",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-40"
        },
        {
          "id": "59756543738142",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-40"
        },
        {
          "id": "59756543770910",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-42"
        },
        {
          "id": "59756543803678",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-42"
        },
        {
          "id": "59756543836446",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-heather-shirt-shoes": {
      "id": "black-heather-shirt-shoes",
      "title": "Black leather loafers",
      "color": "Black",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "stirling-sport-zip-polo--syrah-heather": {
      "id": "stirling-sport-zip-polo--syrah-heather",
      "productId": "stirling-sport-zip-polo",
      "handle": "stirling-sport-zip-polo",
      "title": "Stirling Sport Zip Polo",
      "color": "Syrah Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 16000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/stirling-sport-zip-polo-6327845.jpg?v=1776284841",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/stirling-sport-zip-polo-6327845.jpg?v=1776284841",
      "url": "/products/stirling-sport-zip-polo?variant=50078913200414",
      "variants": [
        {
          "id": "50078913200414",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-R0040-S"
        },
        {
          "id": "50078913233182",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-R0040-M"
        },
        {
          "id": "50078913265950",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-R0040-L"
        },
        {
          "id": "50078913298718",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-R0040-XL"
        },
        {
          "id": "50078913331486",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 16000,
          "sku": "MTK0250-R0040-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-heather-jacket-shoes": {
      "id": "black-heather-jacket-shoes",
      "title": "Black leather Chelsea boots",
      "color": "Black",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    }
  },
  "products": {
    "woolen-fleece-quarter-zip": {
      "id": "woolen-fleece-quarter-zip",
      "title": "Woolen Fleece Quarter Zip",
      "active": true,
      "licensed": false,
      "isLayer": true,
      "enabled": true,
      "colors": [
        "Eucalyptus Heather",
        "Blue Steel Heather",
        "Admiral Heather",
        "Loche Heather",
        "Shadow Heather",
        "Stillwater Heather",
        "Black Heather"
      ],
      "anchorItems": {
        "Eucalyptus Heather": "eucalyptus-heather",
        "Blue Steel Heather": "blue-steel-heather",
        "Admiral Heather": "admiral-heather",
        "Loche Heather": "loche-heather",
        "Shadow Heather": "shadow-heather",
        "Stillwater Heather": "stillwater-heather",
        "Black Heather": "black-heather"
      }
    }
  }
};
const looks = [
  {
    "id": "eucalyptus-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Eucalyptus Heather",
    "title": "Warmth for a cold first tee",
    "image": "assets/wl-woolen-fleece-quarter-zip-eucalyptus-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "avery-ls-polo--antique-white-heather",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--anchor",
      "shoes": "eucalyptus-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "An antique-white long-sleeve polo lifts the substantial green fleece. Anchor performance trousers and ivory spikeless shoes make a sensible cold-day golf outfit.",
    "alt": "Eucalyptus Heather Woolen Fleece Quarter Zip styled with Avery Long Sleeve Performance Polo in Antique White Heather, Tide to Tee Pant in Anchor, Ivory spikeless golf shoes in Ivory with tan trim. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "eucalyptus-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Eucalyptus Heather",
    "title": "Eucalyptus with a blue collar",
    "image": "assets/wl-woolen-fleece-quarter-zip-eucalyptus-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "rockdale-brushed-twill-sport-shirt--luxe-blue",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--stone",
      "shoes": "eucalyptus-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The blue-check collar adds structure above the warm fleece. Stone corduroy and brown loafers bring comfortable texture and relaxed office polish.",
    "alt": "Eucalyptus Heather Woolen Fleece Quarter Zip styled with Rockdale Brushed Twill Sport Shirt in LUXE BLUE, Arthur Corduroy Pant in Stone, Dark brown leather penny loafers in Dark brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "eucalyptus-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Eucalyptus Heather",
    "title": "Oyster knit beneath eucalyptus",
    "image": "assets/wl-woolen-fleece-quarter-zip-eucalyptus-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "stirling-sport-zip-polo--luxe-blue-heather",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--admiral",
      "shoes": "eucalyptus-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A pale blue polo collar brightens the green quarter-zip. Navy corduroy and snuff suede boots add warm texture for an evening out.",
    "alt": "Eucalyptus Heather Woolen Fleece Quarter Zip styled with Stirling Sport Zip Polo in Luxe Blue Heather, Arthur Corduroy Pant in Admiral, Snuff suede Chelsea boots in Snuff brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "blue-steel-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Blue Steel Heather",
    "title": "Blue fleece for a cold weekend",
    "image": "assets/wl-woolen-fleece-quarter-zip-blue-steel-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--white",
      "outerlayer": null,
      "pants": "blue-steel-heather-casual-jeans",
      "shoes": "blue-steel-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": true,
    "description": "A white crewneck edge keeps the warm blue fleece relaxed. Mid-blue straight-leg jeans and sand suede boots suit a crisp weekend afternoon.",
    "alt": "Blue Steel Heather Woolen Fleece Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in White, Your mid-blue straight-leg jeans in Mid-blue, Sand suede desert boots in Sand. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "blue-steel-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Blue Steel Heather",
    "title": "A clean blue collar inside fleece",
    "image": "assets/wl-woolen-fleece-quarter-zip-blue-steel-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "nells-button-front--anchor-blue-steel",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--taupe",
      "shoes": "blue-steel-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The smooth blue knit shirt gives the soft blue quarter-zip a neat collar. Taupe sateen trousers and black loafers add warmth and structure for the office.",
    "alt": "Blue Steel Heather Woolen Fleece Quarter Zip styled with Nells Jacquard Button Front in ANCHOR / BLUE STEEL, Ridge Sateen Pant in Taupe, Black leather loafers in Black. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "blue-steel-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Blue Steel Heather",
    "title": "Warm persimmon under blue",
    "image": "assets/wl-woolen-fleece-quarter-zip-blue-steel-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "leni-2-button-polo--persimmon",
      "outerlayer": null,
      "pants": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "shoes": "blue-steel-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A muted persimmon polo collar brings warmth to the blue fleece. Navy brushed twill and brown suede boots create an easy dinner look.",
    "alt": "Blue Steel Heather Woolen Fleece Quarter Zip styled with Leni Two-Button Polo in PERSIMMON, Bristol Twill Hybrid 5-Pocket Pant in Navy, Dark brown suede Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "admiral-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Admiral Heather",
    "title": "Navy warmth for a winter round",
    "image": "assets/wl-woolen-fleece-quarter-zip-admiral-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "avery-ls-polo--stillwater-heather",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--shadow",
      "shoes": "admiral-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A pale blue long-sleeve polo shows inside the substantial navy fleece. Shadow performance trousers and white spikeless shoes finish a cold-weather golf look.",
    "alt": "Admiral Heather Woolen Fleece Quarter Zip styled with Avery Long Sleeve Performance Polo in Stillwater Heather, Tide to Tee Pant in Shadow, White leather spikeless golf shoes in White with gray trim. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "admiral-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Admiral Heather",
    "title": "A checked collar above navy",
    "image": "assets/wl-woolen-fleece-quarter-zip-admiral-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "highland-brushed-twill--luxe-blue-clementine",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--taupe",
      "shoes": "admiral-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The blue-and-clementine check adds a warm accent at the collar. Taupe sateen trousers and tobacco loafers keep the navy fleece polished for work.",
    "alt": "Admiral Heather Woolen Fleece Quarter Zip styled with Highland Brushed Twill Sport Shirt in Luxe Blue/ Clementine, Ridge Sateen Pant in Taupe, Tobacco suede loafers in Tobacco brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "admiral-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Admiral Heather",
    "title": "Navy fleece with a berry note",
    "image": "assets/wl-woolen-fleece-quarter-zip-admiral-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "bruce-polo--mulled-berry",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--stone",
      "shoes": "admiral-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A muted berry polo collar lends warmth to the navy fleece. Stone corduroy and dark suede Chelsea boots add texture for an evening reservation.",
    "alt": "Admiral Heather Woolen Fleece Quarter Zip styled with Bruce Polo in MULLED BERRY, Arthur Corduroy Pant in Stone, Dark brown suede Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "loche-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Loche Heather",
    "title": "A warm layer for a crisp walk",
    "image": "assets/wl-woolen-fleece-quarter-zip-loche-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--white",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--khaki",
      "shoes": "loche-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Keep a white crewneck edge visible inside the fleece collar. Khaki sateen trousers and sand suede boots let the Loche heather remain the focus.",
    "alt": "Loche Heather Woolen Fleece Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in White, Ridge Sateen Pant in Khaki, Sand suede desert boots in Sand. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "loche-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Loche Heather",
    "title": "Loche with a blue check",
    "image": "assets/wl-woolen-fleece-quarter-zip-loche-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "dario-sportshirt--luxe-blue-navy",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--admiral",
      "shoes": "loche-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The blue-and-navy check collar gives the fleece a tidy workday edge. Navy sateen trousers and brown loafers provide a quiet foundation.",
    "alt": "Loche Heather Woolen Fleece Quarter Zip styled with Dario Cotton Sport Shirt in Luxe Blue / Navy, Ridge Sateen Pant in Admiral, Dark brown leather penny loafers in Dark brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "loche-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Loche Heather",
    "title": "Soft sage for the evening",
    "image": "assets/wl-woolen-fleece-quarter-zip-loche-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "leni-2-button-polo--sage",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--khaki",
      "shoes": "loche-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A muted sage knit polo gives the fleece a soft collar. Khaki corduroy and dark brown suede boots keep the warm textures cohesive.",
    "alt": "Loche Heather Woolen Fleece Quarter Zip styled with Leni Two-Button Polo in SAGE, Arthur Corduroy Pant in Khaki, Dark brown suede Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "shadow-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Shadow Heather",
    "title": "Gray fleece on a cold day",
    "image": "assets/wl-woolen-fleece-quarter-zip-shadow-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--white",
      "outerlayer": null,
      "pants": "stateline-5-pocket-pant-stone--stone",
      "shoes": "shadow-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A white crewneck edge brightens the gray fleece. Stone five-pocket trousers and gray suede sneakers keep the warm outfit relaxed and tonal.",
    "alt": "Shadow Heather Woolen Fleece Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in White, Stateline 5-Pocket Pant (Stone) in Stone, Light gray suede sneakers in Light gray. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "shadow-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Shadow Heather",
    "title": "A wine check beneath gray",
    "image": "assets/wl-woolen-fleece-quarter-zip-shadow-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "olaf-brushed-twill--syrah",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--khaki",
      "shoes": "shadow-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The Syrah check adds a warm accent to the gray stand collar. Khaki sateen trousers and oxblood loafers make a relaxed office look.",
    "alt": "Shadow Heather Woolen Fleece Quarter Zip styled with Olaf Brushed Twill Sport Shirt in Syrah, Ridge Sateen Pant in Khaki, Oxblood leather loafers in Oxblood. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "shadow-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Shadow Heather",
    "title": "Violet against shadow gray",
    "image": "assets/wl-woolen-fleece-quarter-zip-shadow-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "kit-polo--wisteria",
      "outerlayer": null,
      "pants": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "shoes": "shadow-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A pale wisteria polo collar softens the gray fleece. Navy brushed twill and black Chelsea boots give the evening outfit a clean dark base.",
    "alt": "Shadow Heather Woolen Fleece Quarter Zip styled with Kit Polo in WISTERIA, Bristol Twill Hybrid 5-Pocket Pant in Navy, Black leather Chelsea boots in Black. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "stillwater-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Stillwater Heather",
    "title": "Pale blue fleece for the first tee",
    "image": "assets/wl-woolen-fleece-quarter-zip-stillwater-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "avery-ls-polo--thistle-heather",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--anchor",
      "shoes": "stillwater-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A thistle long-sleeve polo adds a subtle cool-toned collar under Stillwater fleece. Anchor performance trousers and ivory spikeless shoes suit a cold morning round.",
    "alt": "Stillwater Heather Woolen Fleece Quarter Zip styled with Avery Long Sleeve Performance Polo in Thistle Heather, Tide to Tee Pant in Anchor, Ivory spikeless golf shoes in Ivory with tan trim. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "stillwater-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Stillwater Heather",
    "title": "Stillwater with a fine check",
    "image": "assets/wl-woolen-fleece-quarter-zip-stillwater-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "market-sportshirt--white-shamrock",
      "outerlayer": null,
      "pants": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "shoes": "stillwater-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A small white-and-green check gives the pale fleece a tidy collar. Navy brushed twill and tobacco loafers add relaxed office structure.",
    "alt": "Stillwater Heather Woolen Fleece Quarter Zip styled with Market Cotton Sport Shirt in White/Shamrock, Bristol Twill Hybrid 5-Pocket Pant in Navy, Tobacco suede loafers in Tobacco brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "stillwater-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Stillwater Heather",
    "title": "A soft green accent at dusk",
    "image": "assets/wl-woolen-fleece-quarter-zip-stillwater-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "bruce-polo--sage",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--admiral",
      "shoes": "stillwater-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A sage knit polo collar complements the pale blue fleece. Navy corduroy and snuff suede boots bring depth to an easy evening outfit.",
    "alt": "Stillwater Heather Woolen Fleece Quarter Zip styled with Bruce Polo in SAGE, Arthur Corduroy Pant in Admiral, Snuff suede Chelsea boots in Snuff brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "black-heather-casual",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Black Heather",
    "title": "Black fleece for an easy afternoon",
    "image": "assets/wl-woolen-fleece-quarter-zip-black-heather-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--white",
      "outerlayer": null,
      "pants": "black-heather-casual-jeans",
      "shoes": "black-heather-casual-shoes"
    },
    "accessories": [],
    "denimApproved": true,
    "description": "A white crewneck edge opens up the dark fleece neckline. Washed black straight-leg jeans and white sneakers keep the warm layer casual.",
    "alt": "Black Heather Woolen Fleece Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in White, Your washed black straight-leg jeans in Washed black, White leather sneakers in White. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "black-heather-shirt",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Black Heather",
    "title": "Black fleece with a pale collar",
    "image": "assets/wl-woolen-fleece-quarter-zip-black-heather-shirt-v1.jpg",
    "pieces": {
      "underlayer": "gunnar-sportshirt--stillwater",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--blue-steel",
      "shoes": "black-heather-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A pale blue gingham collar brings light to the dark quarter-zip. Blue Steel sateen trousers and black loafers make a restrained office palette.",
    "alt": "Black Heather Woolen Fleece Quarter Zip styled with Gunnar Cotton Sport Shirt in Stillwater, Ridge Sateen Pant in Blue Steel, Black leather loafers in Black. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "black-heather-jacket",
    "productId": "woolen-fleece-quarter-zip",
    "color": "Black Heather",
    "title": "Rose under black fleece",
    "image": "assets/wl-woolen-fleece-quarter-zip-black-heather-jacket-v1.jpg",
    "pieces": {
      "underlayer": "stirling-sport-zip-polo--syrah-heather",
      "outerlayer": null,
      "pants": "mbp0019-arthur-corduroy-5-pocket--stone",
      "shoes": "black-heather-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A heathered rose zip-polo collar gives the dark fleece an evening accent. Stone corduroy and black Chelsea boots finish the outfit with texture and contrast.",
    "alt": "Black Heather Woolen Fleece Quarter Zip styled with Stirling Sport Zip Polo in Syrah Heather, Arthur Corduroy Pant in Stone, Black leather Chelsea boots in Black. Head cropped out; shoes visible.",
    "tier": "Refined"
  }
];
function isAnchorEnabled(catalog,id){const p=catalog.products[id];return !!(p?.active&&p.enabled&&p.isLayer&&!p.licensed)}
function isEligiblePiece(item){return !!item&&(item.ownership==='closet'||(item.active&&!item.licensed))}
function validLooks(catalog,looks,productId,color){return looks.filter(l=>l.productId===productId&&l.color===color&&l.image&&Object.values(l.pieces).filter(Boolean).every(id=>isEligiblePiece(catalog.items[id]))&&l.accessories.every(id=>isEligiblePiece(catalog.items[id]))&&(!(catalog.items[l.pieces.pants]?.isDenim||l.pieces.pants==='denim')||l.denimApproved));}
function createState(catalog,looks,{productId,color,lookId,remembered={}}){
 if(!isAnchorEnabled(catalog,productId))throw Error('This layer is not enabled');
 const anchorItemId=catalog.products[productId].anchorItems[color];
 if(!anchorItemId||!isEligiblePiece(catalog.items[anchorItemId]))throw Error('Unsupported color');
 const options=validLooks(catalog,looks,productId,color);if(!options.length)throw Error('No approved look for this color');
 const chosen=options.find(l=>l.id===(lookId||remembered[`${productId}:${color}`]))||options[0];
 return {productId,color,anchorItemId,lookId:chosen.id,pieces:{...chosen.pieces},validLookIds:options.map(l=>l.id),remembered:{...remembered,[`${productId}:${color}`]:chosen.id}};
}
function changeAnchor(state,catalog,looks,next){return createState(catalog,looks,{...next,remembered:state.remembered})}
function getChoices(state,looks,role){return [...new Set(looks.filter(l=>state.validLookIds.includes(l.id)).map(l=>l.pieces[role]))]}
function choosePiece(state,looks,role,pieceId){const candidates=looks.filter(l=>state.validLookIds.includes(l.id)&&l.pieces[role]===pieceId);if(!candidates.length)throw Error('This pairing is not available');const chosen=candidates.find(l=>l.id===state.lookId)||candidates.sort((a,b)=>Object.keys(state.pieces).filter(k=>a.pieces[k]!==state.pieces[k]).length-Object.keys(state.pieces).filter(k=>b.pieces[k]!==state.pieces[k]).length)[0];return {state:{...state,lookId:chosen.id,pieces:{...chosen.pieces},remembered:{...state.remembered,[`${state.productId}:${state.color}`]:chosen.id}},changedRoles:Object.keys(state.pieces).filter(k=>k!==role&&state.pieces[k]!==chosen.pieces[k])}}
function getCoverage(catalog,looks){return Object.values(catalog.products).filter(p=>isAnchorEnabled(catalog,p.id)).flatMap(p=>p.colors.filter(c=>!validLooks(catalog,looks,p.id,c).length).map(color=>({productId:p.id,color})))}

class ImageCoordinator{
 constructor(loader){this.loader=loader;this.revision=0;this.disposed=false}
 async show(id,success,failure=()=>{}){const revision=++this.revision;try{const result=await this.loader(id);if(!this.disposed&&revision===this.revision)success(result)}catch(error){if(!this.disposed&&revision===this.revision)failure(error)}}
 destroy(){this.disposed=true;this.revision++}
}
function loadImage(src){return new Promise((resolve,reject)=>{const img=new Image();img.onload=()=>resolve(img);img.onerror=()=>reject(Error('This styled image could not load.'));img.src=src})}

function createReview(state,catalog,requestId,onlyItem){const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])];return {requestId,color:state.color,lookId:state.lookId,closetItemIds:ids.filter(id=>catalog.items[id]?.ownership==='closet'),rows:ids.filter(id=>(!onlyItem||id===onlyItem)&&catalog.items[id]?.ownership==='turtleson').map(itemId=>({itemId,included:true,quantity:1,options:{},priceCents:catalog.items[itemId].priceCents,currency:catalog.items[itemId].currency}))}}
function validateReview(review,catalog){const errors=[],lines=[];for(const row of review.rows.filter(r=>r.included)){const item=catalog.items[row.itemId];if(!isEligiblePiece(item)||item.ownership!=='turtleson'||!item.verified){errors.push('This item is not available to buy.');continue}if(!Number.isInteger(row.quantity)||row.quantity<1||row.quantity>10){errors.push('Choose a quantity from 1 to 10.');continue}const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v)&&Object.keys(row.options).every(k=>k in v.options));if(!variant){errors.push(`Choose all sizes for ${item.title||item.id}.`);continue}if(!variant.available){errors.push(`${item.title||item.id} is unavailable in that size.`);continue}if(variant.priceCents!==row.priceCents||item.currency!==row.currency){errors.push('Price changed. Please reopen the review.');continue}lines.push({itemId:item.id,variantId:variant.id,quantity:row.quantity,options:{...variant.options},priceCents:variant.priceCents,currency:item.currency,title:item.title,color:item.color,image:item.image,url:item.url})}if(!review.rows.some(r=>r.included))errors.push('Select at least one item.');if(new Set(lines.map(l=>l.currency)).size>1)errors.push('Currencies must match.');return {ok:!errors.length,errors,lines,subtotalCents:lines.reduce((n,l)=>n+l.quantity*l.priceCents,0),currency:lines[0]?.currency||'USD'}}

const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:activeCurrency,maximumFractionDigits:2}).format(cents/100);
const esc=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function icon(id){const paths={sneakers:'<path d="M12 49l14-23 14 6 8 13 30 8q14 3 12 13H10z"/><path d="M10 65h80M31 36l15 4M28 42l18 4"/>',loafers:'<path d="M10 55l12-21q15-6 26 6l12 12 22 2q11 3 8 13H10z"/><path d="M27 36l5 19 18-3M10 66h80"/>',boots:'<path d="M25 15h28l-2 31 17 7 17 3q9 2 7 12H20l-2-16z"/><path d="M20 66h72M34 18l-4 28 14 3 6-31"/>',denim:'<path d="M25 13h50l-2 25-9 42H49l1-37-10 37H25l1-42z"/><path d="M26 24h47M48 14l2 24M30 26l-2 10M65 26l4 10"/>',watch:'<path d="M43 9h16v21H43zM43 64h16v24H43z"/><circle cx="51" cy="48" r="21"/><path d="M51 35v13l10 6"/>',sunglasses:'<path d="M10 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM57 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM43 39q7-5 14 0M10 38l-6-12M90 38l6-12"/>'};return `<svg viewBox="0 0 100 100" aria-hidden="true" class="closet-icon"><g fill="${id==='denim'?'#334762':id==='sneakers'?'#fcfaf5':'#c5aa84'}" stroke="#74614b" stroke-width="2" stroke-linejoin="round">${paths[id]||paths.watch}</g></svg>`}
function itemImage(item,cls=''){return item.image?`<img class="${cls}" src="${esc(item.image)}" alt="${esc(item.title+' · '+item.color)}" loading="lazy">`:icon(item.icon||item.id)}
function swatches(state,catalog,looks){const colors=catalog.products[state.productId].colors.filter(color=>{try{createState(catalog,looks,{productId:state.productId,color});return true}catch{return false}});return `<div class="anchor-colors"><span class="color-picker-label">Explore this layer in</span><div class="swatches" role="group" aria-label="Starting layer color">${colors.map(color=>`<button type="button" class="wl-color-swatch" data-color="${esc(color)}" aria-label="${esc(color)}" title="${esc(color)}" aria-pressed="${state.color===color}"><span class="wl-color-dot" aria-hidden="true"></span></button>`).join('')}</div></div>`}
const roleNames={underlayer:'Underlayer',outerlayer:'Outer layer',pants:'Bottoms',shoes:'Shoes'};
class Studio{
 constructor(root,{catalog,looks,state,onChange,onReview,onQuickView,onColor}){Object.assign(this,{root,catalog,looks,state,onChange,onReview,onQuickView,onColor});this.images=new ImageCoordinator(loadImage);this.clickHandler=event=>this.click(event);root.addEventListener('click',this.clickHandler);this.render()}
 setState(state){this.state=state;this.render()}
 chooseLook(id){const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};this.state=createState(this.catalog,this.looks,{...this.state,lookId:id});this.onChange(this.state);this.render();this.root.getBoundingClientRect();window.scrollTo(viewport);requestAnimationFrame(()=>{if(this.root.isConnected){window.scrollTo(viewport);}})}
 click(event){const button=event.target.closest('button');if(!button)return;const {color,look,buy,retry,quickview}=button.dataset;if(quickview){this.onQuickView?.(quickview,button);return;}if(color){if(this.onColor){this.onColor(color);return;}this.state=changeAnchor(this.state,this.catalog,this.looks,{productId:this.state.productId,color});this.onChange(this.state);this.render()}else if(look)this.chooseLook(look);else if(buy)this.onReview(buy==='look'?undefined:buy);else if(retry)this.render();}
 render(){if(this.state.stylingEnabled===false){this.root.replaceChildren();return}const active=document.activeElement;const focus=active&&this.root.contains(active)?{label:active.getAttribute('aria-label'),look:active.dataset.look}:null;const state=this.state,anchor=this.catalog.items[state.anchorItemId],look=this.looks.find(l=>l.id===state.lookId),options=this.looks.filter(l=>state.validLookIds.includes(l.id)),index=options.findIndex(l=>l.id===look.id);this.root.innerHTML=`
 <div class="studio-heading"><div><p class="eyebrow">Plays well with others</p><h2>Wardrobe Logic</h2><p class="subhead">Your Woolen Fleece Quarter Zip. Ready for life’s moments.</p></div><div class="anchor-lock">${itemImage(anchor)}<div><span class="eyebrow">Your starting layer · locked</span><strong>Woolen Fleece Quarter Zip</strong><small>${esc(state.color)}</small>${swatches(state,this.catalog,this.looks)}</div></div></div>
 <div class="studio-body"><div class="visual-column"><div class="outfit-stage"><div class="main-scene" tabindex="0" aria-label="Styled look. Use left and right arrow keys to change look." aria-busy="true"><div class="scene-status">Preparing your look…</div><img class="outfit-photo" alt="${esc(look.alt)}" hidden><span class="scene-tag">${esc(state.color.replace(' Heather',''))} / ${String(index+1).padStart(2,'0')}</span></div><div class="alternate-rail">${options.filter(l=>l.id!==look.id).slice(0,2).map(l=>`<button data-look="${l.id}" class="alternate"><img src="${l.image}" alt="${esc(l.alt)}"><span>${esc(l.title)}</span><small>${esc(l.tier)} · View this look</small></button>`).join('')}</div></div><div class="look-caption"><button class="round" data-look="${options[(index+options.length-1)%options.length].id}" aria-label="Previous look">‹</button><div><span class="eyebrow">${String(index+1).padStart(2,'0')} / ${String(options.length).padStart(2,'0')} ways to wear it</span><h3>${esc(look.title)}</h3></div><button class="round" data-look="${options[(index+1)%options.length].id}" aria-label="Next look">›</button></div><p class="look-description">${esc(look.description)}</p><div class="look-dots" aria-label="Choose a complete look">${options.map((l,i)=>`<button data-look="${l.id}" aria-label="Look ${i+1}: ${esc(l.title)}" aria-pressed="${l.id===look.id}" class="${l.id===look.id?'active':''}"></button>`).join('')}</div></div>
 <div class="builder"><div class="builder-heading"><p class="eyebrow">Make the look yours</p><h3>In this look</h3><p>The pieces in your selected look.</p><div class="swatches layer-color-summary"><span>${esc(state.color)} · follows your selected Woolen Fleece Quarter Zip</span></div></div>${Object.keys(roleNames).map(role=>this.row(role)).join('')}<button class="primary look-buy" data-buy="look">Add this look to cart <span>→</span></button><p class="buy-note">Choose your sizes first. Keep the pieces you need.</p></div></div><p class="studio-footnote">Styled imagery is illustrative. Jeans and shoes are styling suggestions from your own closet.</p><div class="sr-only studio-live" aria-live="polite"></div>`;
 const scene=this.root.querySelector('.main-scene'),photo=scene.querySelector('img'),status=scene.querySelector('.scene-status');this.images.show(look.image,img=>{photo.src=img.src;photo.hidden=false;status.hidden=true;scene.setAttribute('aria-busy','false')},()=>{status.innerHTML=`<img class="anchor-fallback" src="${esc(anchor.image)}" alt="${esc(anchor.title+' · '+anchor.color)}"><span>Your styled image is unavailable.</span><button class="text-button" data-retry="true">Try again</button>`;scene.setAttribute('aria-busy','false')});
 scene.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.chooseLook(options[(index+(e.key==='ArrowRight'?1:options.length-1))%options.length].id);this.root.querySelector('.main-scene').focus({preventScroll:true})}});
 if(focus){const buttons=Array.from(this.root.querySelectorAll('button'));const target=buttons.find(b=>focus.label&&b.getAttribute('aria-label')===focus.label)||scene;target.focus({preventScroll:true})}
 let touchStart;scene.addEventListener('touchstart',e=>touchStart=e.changedTouches[0].clientX,{passive:true});scene.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchStart;if(Math.abs(dx)>60)this.chooseLook(options[(index+(dx<0?1:options.length-1))%options.length].id)},{passive:true});
 }
 row(role){const id=this.state.pieces[role],item=this.catalog.items[id];if(!item)return '';return `<div class="piece-row" data-piece-id="${esc(id)}"><div class="row-label"><span class="eyebrow">${roleNames[role]}</span><small>${item.ownership==='closet'?'From your closet':'Turtleson'}</small></div><div class="piece-content"><div class="piece-image">${itemImage(item)}</div><div class="piece-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color||item.note||'')}</small>${item.ownership==='turtleson'?`<div class="piece-links">${this.onQuickView?`<button class="text-button view-piece" data-quickview="${esc(id)}" aria-label="Quick view ${esc(item.title)}">View piece</button>`:`<a href="${item.url}" target="_blank" rel="noopener">View piece ↗</a>`}<span>${money(item.priceCents)}</span></div>`:''}</div>${item.ownership==='turtleson'?`<button class="round add-piece" data-buy="${esc(id)}" aria-label="Add ${esc(item.title)}">＋</button>`:''}</div></div>`}
 destroy(){this.root.removeEventListener('click',this.clickHandler);this.images.destroy();this.root.replaceChildren()}
}

function hydrateItem(item, product, currency) {
  if (!product || /licensed|collegiate|ncaa|fanshop/i.test((product.tags || []).join(' '))) return {...item, active:false, verified:false, variants:[]};
  const names = product.options.map(o => typeof o === 'string' ? o : o.name);
  const colorIndex = names.findIndex(n => /^(color|colour)$/i.test(n));
  const variants = product.variants.filter(v => colorIndex < 0 || String(v.options[colorIndex]).toLowerCase() === item.color.toLowerCase()).map(v => ({id:String(v.id), options:Object.fromEntries(names.map((n,i)=>[n,v.options[i]]).filter(([n])=>!/^(color|colour)$/i.test(n))), available:v.available, priceCents:v.price, sku:v.sku}));
  const live = product.variants.find(v => variants.some(x=>x.id===String(v.id)) && v.available) || product.variants.find(v=>variants.some(x=>x.id===String(v.id)));
  return {...item,title:product.title,currency,active:variants.length>0,verified:true,variants,priceCents:live?.price || item.priceCents,image:live?.featured_image?.src || item.sourceImage,url:`${globalThis.Shopify?.routes?.root || '/'}products/${item.handle}?variant=${live?.id || ''}`};
}
function attemptStatus(cart, attempt, lines) {
  const found = (cart.items || []).filter(i=>i.properties?._wardrobe_logic_attempt===attempt);
  if (!found.length) return 'absent';
  return lines.every(l=>found.filter(i=>String(i.variant_id)===String(l.variantId)).reduce((n,i)=>n+i.quantity,0)>=l.quantity) ? 'complete':'partial';
}
async function addReviewedLook({request, root, attempt, lines, persist}) {
  const before = await request(root+'cart.js');
  const prior = attemptStatus(before,attempt,lines);
  if (prior!=='absent') return {status:prior,cart:before};
  persist({attempt,lines});
  let response, failure;
  try { response = await request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:lines.map(l=>({id:l.variantId,quantity:l.quantity,properties:{_wardrobe_logic_attempt:attempt}}))})}); } catch(e) { failure=e; }
  try {
    const cart = await request(root+'cart.js');
    const status = attemptStatus(cart,attempt,lines);
    if (status!=='absent') return {status,cart};
    if (response) return {status:'uncertain',cart};
    if (failure?.definite) return {status:'rejected',cart,message:failure.message};
    return {status:'uncertain',cart};
  } catch { return {status:'uncertain'}; }
}

function quickViewImages(item,product){
 const source=image=>{const url=typeof image==='string'?image:image?.src;return url?.startsWith('//')?'https:'+url:url;};
 const names=product.options.map(o=>typeof o==='string'?o:o.name),ci=names.findIndex(n=>/^(color|colour)$/i.test(n));
 const colorVariants=product.variants.filter(v=>ci<0||String(v.options[ci]).toLowerCase()===item.color.toLowerCase());
 const singleColor=ci<0||new Set(product.variants.map(v=>v.options[ci])).size===1;
 const images=product.images.map(source).filter(Boolean),selected=new Set(colorVariants.map(v=>source(v.featured_image)).filter(Boolean));
 const other=new Set(product.variants.filter(v=>ci>=0&&String(v.options[ci]).toLowerCase()!==item.color.toLowerCase()).map(v=>source(v.featured_image)).filter(Boolean));
 let within=false;
 const gallery=singleColor?images:images.filter(src=>{if(other.has(src)){within=false;return false;}if(selected.has(src))within=true;return within;});
 return [...new Set([source(item.image),...selected,...gallery].filter(Boolean))];
}
function quickViewVariant(item,options){return item.variants.find(v=>v.available&&Object.entries(v.options).every(([name,value])=>options[name]===value));}
function quickDescription(html){
 const doc=new DOMParser().parseFromString(html||'','text/html');
 doc.querySelectorAll('script,style,iframe,object').forEach(el=>el.remove());
 const blocks=[...doc.body.querySelectorAll('p,li,h2,h3,h4')].filter(el=>!el.querySelector('p,li')).map(el=>({tag:el.closest('li')?'li':'p',text:el.textContent.trim()})).filter(el=>el.text);
 if(!blocks.length)return `<p>${esc(doc.body.textContent.trim())}</p>`;
 return blocks.map(b=>`<${b.tag}>${esc(b.text)}</${b.tag}>`).join('').replace(/(?:<li>[\s\S]*?<\/li>)+/g,list=>`<ul>${list}</ul>`);
}
class PieceQuickView{
 constructor({host,catalog,getProduct,onReview}){
  Object.assign(this,{host,catalog,getProduct,onReview});this.version=0;this.lifetime=new AbortController();
  this.dialog=document.createElement('dialog');this.dialog.className='wl-quick-view';this.dialog.setAttribute('aria-labelledby','wl-quick-title');host.append(this.dialog);
  this.dialog.addEventListener('close',()=>{this.version++;if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});},{signal:this.lifetime.signal});
  this.dialog.addEventListener('click',e=>{const action=e.target.closest('button');if(action?.hasAttribute('data-quick-close'))this.close();if(action?.hasAttribute('data-quick-review')){const options={...this.options},id=this.item.id;this.close();this.onReview(id,options);}if(action?.hasAttribute('data-quick-retry'))this.open(this.item.id,this.trigger);if(action?.hasAttribute('data-quick-image'))this.selectPhoto(Number(action.dataset.quickImage));if(action?.hasAttribute('data-quick-step'))this.selectPhoto(this.photoIndex+Number(action.dataset.quickStep));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}},{signal:this.lifetime.signal});
  this.dialog.addEventListener('change',e=>{if(!e.target.matches('[data-quick-option]'))return;this.options[e.target.dataset.quickOption]=e.target.value;this.update();},{signal:this.lifetime.signal});
 }
 close(){this.version++;if(this.dialog.open)this.dialog.close();}
 async open(id,trigger){
  const version=++this.version;this.trigger=trigger;this.item=this.catalog.items[id];this.options={};
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p role="status">Loading the details…</p>`;
  if(!this.dialog.open)this.dialog.showModal();
  try{const product=await this.getProduct(this.item);if(version!==this.version||!this.dialog.open)return;this.item=this.catalog.items[id];if(!this.item.active||!this.item.verified)throw new Error('Unavailable');this.product=product;this.render();}catch{if(version!==this.version||!this.dialog.open)return;this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p>We couldn’t load the current details. You can try again or return to your look.</p><button class="primary" data-quick-retry>Try again</button><a class="text-button" href="${esc(this.item.url)}" target="_blank" rel="noopener">View full product details ↗</a>`;}
 }
 render(){
  const item=this.item,images=quickViewImages(item,this.product),names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">Turtleson · A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view">×</button></div><div class="quick-grid"><div class="quick-media"><div class="quick-gallery" tabindex="0" role="region" aria-label="${esc(item.title)} product photos">${images.map((src,i)=>`<img class="quick-photo" src="${esc(src)}" alt="${esc(item.title+' · '+item.color+' · Photo '+(i+1)+' of '+images.length)}" loading="${i===0?'eager':'lazy'}">`).join('')}</div>${images.length>1?`<div class="quick-gallery-controls"><button class="round" data-quick-step="-1" aria-label="Previous product photo" disabled>‹</button><span class="quick-photo-count" aria-live="polite">1 / ${images.length}</span><button class="round" data-quick-step="1" aria-label="Next product photo">›</button></div><div class="quick-thumbs" aria-label="Product photos">${images.map((src,i)=>`<button data-quick-image="${i}" aria-label="Product photo ${i+1}" aria-pressed="${i===0}"><img src="${esc(src)}" alt="" loading="lazy"></button>`).join('')}</div>`:''}</div><div class="quick-copy"><h2 id="wl-quick-title">${esc(item.title)}</h2><p class="quick-color">${esc(item.color)}</p><p class="quick-price">${money(item.priceCents)}</p><p class="quick-context">Selected to complement your Woolen Fleece Quarter Zip.</p><div class="quick-options">${names.map(name=>`<label>${esc(name)}<select data-quick-option="${esc(name)}" aria-label="${esc(name)} for ${esc(item.title)}"><option value="">Select ${esc(name.toLowerCase())}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}">${esc(value)}</option>`).join('')}</select></label>`).join('')}</div><p class="quick-selection" role="status"></p><button class="primary" data-quick-review disabled>Review &amp; add this piece <span>→</span></button><button class="text-button quick-return" data-quick-close>Return to your look</button><details class="quick-description"><summary>About this piece</summary>${quickDescription(this.product.description)}</details><a class="quick-full" href="${esc(item.url)}" target="_blank" rel="noopener">View full product details ↗</a></div></div>`;
  this.photos=images;this.photoIndex=0;
  const gallery=this.dialog.querySelector('.quick-gallery');
  gallery.addEventListener('scroll',()=>{this.photoIndex=Math.max(0,Math.min(this.photos.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));this.updateGallery();},{passive:true,signal:this.lifetime.signal});
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.selectPhoto(this.photoIndex+(e.key==='ArrowRight'?1:-1));}},{signal:this.lifetime.signal});
  this.update();this.dialog.querySelector('[data-quick-close]').focus({preventScroll:true});
 }
 selectPhoto(index){
  const gallery=this.dialog.querySelector('.quick-gallery');
  this.photoIndex=Math.max(0,Math.min(this.photos.length-1,index));
  gallery.scrollTo({left:this.photoIndex*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.updateGallery();
 }
 updateGallery(){
  this.dialog.querySelectorAll('[data-quick-image]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.quickImage)===this.photoIndex)));
  const count=this.dialog.querySelector('.quick-photo-count');if(count)count.textContent=`${this.photoIndex+1} / ${this.photos.length}`;
  const previous=this.dialog.querySelector('[data-quick-step="-1"]'),next=this.dialog.querySelector('[data-quick-step="1"]');
  if(previous)previous.disabled=this.photoIndex===0;if(next)next.disabled=this.photoIndex===this.photos.length-1;
 }
 update(){
  const item=this.item,variant=quickViewVariant(item,this.options);
  this.dialog.querySelectorAll('[data-quick-option]').forEach(select=>{const name=select.dataset.quickOption;[...select.options].filter(o=>o.value).forEach(option=>{const available=item.variants.some(v=>v.available&&v.options[name]===option.value&&Object.entries(this.options).filter(([n,value])=>n!==name&&value).every(([n,value])=>v.options[n]===value));option.disabled=!available;option.textContent=option.value+(available?'':' — unavailable');});});
  this.dialog.querySelector('[data-quick-review]').disabled=!variant;
  this.dialog.querySelector('.quick-price').textContent=money(variant?.priceCents??item.priceCents);
  this.dialog.querySelector('.quick-selection').textContent=!item.variants.some(v=>v.available)?'This color is currently sold out.':variant?'Your size is available. Review it before adding.':'Choose your size to review this piece.';
 }
 destroy(){this.close();this.lifetime.abort();this.dialog.remove();}
}

const initialized = new WeakSet();
const controllers = new Map();
async function request(url, options) {
 const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
 const data = await response.json();
 if(!response.ok){const error=new Error(data.description || 'This selection could not be added.');error.definite=response.status>=400&&response.status<500;throw error;}
 return data;
}
async function initialize(host){
 if(initialized.has(host))return;initialized.add(host);
 const config=JSON.parse(host.querySelector('[data-wl-config]').textContent),rootPath=config.root,landing=config.landing;
 activeCurrency=config.currency;
 const localCatalog=structuredClone(catalog),localLooks=structuredClone(looks);
 const ui=host.querySelector('[data-wl-studio]'),reviewDialog=host.querySelector('dialog');
 for(const item of Object.values(localCatalog.items))if(item.ownership==='turtleson')item.image=item.sourceImage;
 for(const look of localLooks)look.image=config.images[look.id];
 let state,studio,review=null,returnFocus,pending=false,opening=false,revision=0,unresolved=null,queuedState=null;
 try{unresolved=JSON.parse(sessionStorage.getItem('turtleson-wl-pending')||'null');}catch{}
 const lifetime=new AbortController();let observer;controllers.set(host,()=>{revision++;lifetime.abort();observer?.disconnect();studio?.destroy();quickView?.destroy();initialized.delete(host);});
 let arrivalTimer,arrivalCleanup;
 function arriveAtStyling(){
  const destination=host.querySelector('#wardrobe');if(!destination)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header=document.querySelector('[data-section-type="header"]')||document.querySelector('header');
  const headerHeight=header?Math.max(0,header.getBoundingClientRect().bottom):100;
  const top=Math.max(0,window.scrollY+destination.getBoundingClientRect().top-headerHeight-20);
  const url=new URL(location.href);url.hash='wardrobe';history.replaceState(null,'',url);
  clearTimeout(arrivalTimer);arrivalCleanup?.();destination.classList.remove('wl-arriving');
  let finished=false;
  const finish=()=>{if(finished)return;finished=true;clearTimeout(arrivalTimer);arrivalCleanup?.();destination.focus({preventScroll:true});if(!reduced)destination.classList.add('wl-arriving');};
  arrivalCleanup=()=>window.removeEventListener('scrollend',finish);
  if(!reduced)window.addEventListener('scrollend',finish,{once:true,signal:lifetime.signal});
  window.scrollTo({top,behavior:reduced?'instant':'smooth'});
  if(reduced||Math.abs(window.scrollY-top)<2)finish();else arrivalTimer=setTimeout(finish,1600);
 }
 document.addEventListener('click',event=>{
  const link=event.target.closest('a');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  if(!link.closest('[data-wl-jump]')&&!(host.contains(link)&&link.getAttribute('href')?.endsWith('#wardrobe')))return;
  event.preventDefault();event.stopPropagation();arriveAtStyling();
 },{capture:true,signal:lifetime.signal});
 lifetime.signal.addEventListener('abort',()=>{clearTimeout(arrivalTimer);arrivalCleanup?.();});
 const detailGroup=document.querySelector('.wl-product-details');
 if(detailGroup){
  const details=[...detailGroup.querySelectorAll('.accordion')].map(accordion=>({button:accordion.querySelector('button'),panel:accordion.querySelector('.accordion__content'),inner:accordion.querySelector('.accordion__inner')})).filter(detail=>detail.button&&detail.panel&&detail.inner);
  function setDetail(detail,open){
   detail.button.setAttribute('aria-controls',detail.panel.id);
   detail.button.setAttribute('aria-expanded',String(open));
   detail.inner.dataset.open=String(open);
   detail.panel.setAttribute('aria-hidden',String(!open));
   detail.panel.style.display=open?'block':'none';
   detail.panel.style.removeProperty('height');
   detail.panel.style.removeProperty('overflow');
  }
  details.forEach(detail=>setDetail(detail,false));
  detailGroup.addEventListener('click',event=>{
   const selected=details.find(detail=>detail.button.contains(event.target));if(!selected)return;
   event.preventDefault();event.stopImmediatePropagation();
   const open=selected.button.getAttribute('aria-expanded')!=='true';
   details.forEach(detail=>setDetail(detail,detail===selected&&open));
  },{capture:true,signal:lifetime.signal});
 }
 async function refresh(ids){
  const handles=[...new Set(ids.map(id=>localCatalog.items[id].handle))];
  const products=new Map(await Promise.all(handles.map(async handle=>{try{return [handle,await request(rootPath+'products/'+handle+'.js')]}catch{return [handle,null]}})));
  for(const id of ids){const item=localCatalog.items[id];localCatalog.items[id]=hydrateItem(item,products.get(item.handle),config.currency);}
 }
 const quickView=new PieceQuickView({host,catalog:localCatalog,getProduct:async item=>{const product=await request(rootPath+'products/'+item.handle+'.js');localCatalog.items[item.id]=hydrateItem(item,product,config.currency);return product;},onReview:openReview});
 function selectedColor(){return document.querySelector('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"] .product__color-swatch.selected')?.getAttribute('data-option-value') || config.color;}
 function selectedAnchorOptions(){const selected=document.querySelector('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"] .dynamic-variant-button.selected[data-option-value]');const form=document.querySelector('[data-product-form][data-product-handle="woolen-fleece-quarter-zip"]');const variant=Object.values(localCatalog.items).filter(i=>i.handle==='woolen-fleece-quarter-zip').flatMap(i=>i.variants).find(v=>v.id===form?.querySelector('[name="id"]')?.value);const sizeButtons=document.querySelectorAll('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"] .product__chip.selected');return sizeButtons.length&&variant?variant.options:{};}
 function closeReview(){if(pending)return;if(reviewDialog.open)reviewDialog.close();review=null;}
 function updateState(next,push=true){revision++;closeReview();state=next;if(landing&&push){const url=new URL(location.href);url.searchParams.set('color',state.color);url.searchParams.set('look',state.lookId);history.pushState(null,'',url);}else if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}syncLinks();}
 function chooseStudioColor(color){
  if(pending)return;
  const control=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"] .product__color-swatch')).find(button=>button.dataset.optionValue===color);
  if(!control){notify('Please choose this color in the product options above.');return;}
  const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};
  control.click();
  showState(selectedColor());
  window.scrollTo(viewport);
  requestAnimationFrame(()=>{if(ui.isConnected)window.scrollTo(viewport);});
 }
 function syncLinks(){ui.querySelectorAll('.wl-color-swatch').forEach(button=>{const original=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"] .product__color-swatch')).find(control=>control.dataset.optionValue===button.dataset.color);const image=original?.querySelector('img');const dot=button.querySelector('.wl-color-dot');dot.style.backgroundColor=original?.style.backgroundColor||'';dot.style.backgroundImage=image?`url("${image.currentSrc||image.src}")`:'';});const preview=new URL(location.href).searchParams.get('preview_theme_id');host.querySelectorAll('a').forEach(a=>{const url=new URL(a.href,location.href);if(url.origin===location.origin&&preview)url.searchParams.set('preview_theme_id',preview);if(landing&&url.pathname.endsWith('/products/woolen-fleece-quarter-zip')){url.searchParams.set('variant',localCatalog.items[state.anchorItemId].variants.find(v=>v.available)?.id||'');url.searchParams.set('look',state.lookId);}a.href=url;});if(landing){const hero=host.querySelector('.intro-photo img');if(hero){hero.src=config.images[state.anchorItemId+'-jacket'];hero.alt=state.color+' Woolen Fleece Quarter Zip with a coordinated jacket, head cropped out';}}else{document.querySelectorAll('[data-wl-preview]').forEach(img=>{img.src=config.images[state.anchorItemId+'-'+img.dataset.wlPreview];});}}
 function showState(color,look){revision++;if(pending){queuedState={color,look};return;}closeReview();quickView.close();try{const next=createState(localCatalog,localLooks,{productId:"woolen-fleece-quarter-zip",color,lookId:look,remembered:state?.remembered||{}});state=next;host.hidden=false;host.querySelector('[data-wl-title]')?.remove();if(studio)studio.setState(state);else studio=new Studio(ui,{catalog:localCatalog,looks:localLooks,state,onChange:next=>{updateState(next);queueMicrotask(syncLinks);},onReview:openReview,onQuickView:(id,trigger)=>quickView.open(id,trigger),onColor:landing?undefined:chooseStudioColor});syncLinks();if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=false;}catch{host.hidden=false;studio?.destroy();studio=null;state=null;ui.innerHTML=`<div class="studio-heading"><div><p class="eyebrow">Wardrobe Logic / Woolen Fleece Quarter Zip</p><h2>More ways to wear it.</h2><p class="subhead">Choose your stock Woolen Fleece Quarter Zip color to explore three considered looks.</p><p>Choose a color below to explore its coordinated looks.</p>${swatches({productId:"woolen-fleece-quarter-zip",color},localCatalog,localLooks)}</div></div>`;ui.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>chooseStudioColor(button.dataset.color)));const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=true;}}
 async function openReview(onlyItem,selectedOptions){
  if(opening||pending)return;if(unresolved){showRecovery();return;}opening=true;returnFocus=document.activeElement;const version=revision;
  const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])].filter(id=>localCatalog.items[id]?.ownership==='turtleson');
  notify('Checking sizes and availability…');await refresh(ids);opening=false;if(version!==revision)return;
  review=createReview(state,localCatalog,crypto.randomUUID(),onlyItem);
  const chosen=review.rows.find(row=>row.itemId===onlyItem);if(chosen&&selectedOptions)chosen.options={...selectedOptions};
  const anchor=review.rows.find(r=>r.itemId===state.anchorItemId);if(anchor&&!landing)anchor.options={...selectedAnchorOptions()};
  review.closetItemIds=[...new Set([...review.closetItemIds,...(localLooks.find(l=>l.id===review.lookId)?.accessories||[])])];
  renderReview();reviewDialog.showModal();
 }
 function notify(message){const toast=host.querySelector('.toast');toast.textContent=message;toast.hidden=false;clearTimeout(notify.timer);notify.timer=setTimeout(()=>toast.hidden=true,5000);}
 function renderReview(){reviewDialog.innerHTML=`<div class="dialog-heading"><div><p class="eyebrow">Make the look yours</p><h2 id="review-title">A few good choices.</h2><p>${esc(review.color)} · ${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</p></div><button class="round close-review" aria-label="Close outfit review">×</button></div>${review.lookId?`<div class="review-look"><img src="${esc(localLooks.find(l=>l.id===review.lookId)?.image)}" alt="${esc(localLooks.find(l=>l.id===review.lookId)?.alt)}"><div><span class="eyebrow">Your look</span><h3>${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</h3><p>Start with your Woolen Fleece Quarter Zip.<br>Add only what you need.</p></div></div>`:''}<p class="review-intro">Choose sizes for the pieces you want. Already own something? Simply leave it out.</p><div class="review-rows">${review.rows.map((row,i)=>{const item=localCatalog.items[row.itemId];const names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];return `<div class="review-row ${!row.included?'excluded':''}"><label class="include-label"><input type="checkbox" data-include="${i}" ${row.included?'checked':''}><span class="sr-only">Include ${esc(item.title)}</span></label><div class="review-image">${itemImage(item)}</div><div class="review-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color)} · <span data-wl-row-price="${i}">${money(row.priceCents)}</span></small><div class="review-options">${names.map(name=>`<label>${name}<select data-row="${i}" data-option="${name}" aria-label="${esc(item.title+' '+name)}" ${!row.included?'disabled':''}><option value="">Choose ${name.toLowerCase()}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}" ${!item.variants.some(v=>v.available&&v.options[name]===value)?'disabled':''} ${row.options[name]===value?'selected':''}>${esc(value)}${!item.variants.some(v=>v.available&&v.options[name]===value)?' — sold out':''}</option>`).join('')}</select></label>`).join('')}<label>Qty<select data-quantity="${i}" aria-label="${esc(item.title)} quantity" ${!row.included?'disabled':''}>${[1,2,3,4,5].map(n=>`<option ${row.quantity===n?'selected':''}>${n}</option>`).join('')}</select></label></div></div></div>`}).join('')}</div><div class="review-closet"><span>Already in your wardrobe</span><p>${review.closetItemIds.map(id=>esc(localCatalog.items[id].title)).join(' · ')||'No additional closet references in this selection.'}</p><p>Styling inspiration only. These won't be added to your bag.</p></div><div id="review-error" class="form-error" role="alert"></div><div class="review-bottom"><div><small>Selected pieces</small><strong id="review-subtotal"></strong><small>Shipping and taxes calculated at checkout.</small></div><button class="primary confirm-add">Add selected to cart <span>→</span></button></div><p class="preview-disclaimer">Only your selected Turtleson pieces are added. <a href="${rootPath}cart">View your cart ↗</a></p>`;reviewDialog.querySelector('.close-review').onclick=closeReview;reviewDialog.querySelectorAll('[data-include]').forEach(input=>input.onchange=()=>{review.rows[Number(input.dataset.include)].included=input.checked;renderReview();reviewDialog.querySelector(`[data-include="${input.dataset.include}"]`).focus()});reviewDialog.querySelectorAll('[data-option]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.row)].options[select.dataset.option]=select.value;updateSubtotal()});reviewDialog.querySelectorAll('[data-quantity]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.quantity)].quantity=Number(select.value);updateSubtotal()});reviewDialog.querySelector('.confirm-add').onclick=confirmAdd;updateSubtotal()}

 function updateSubtotal(){if(!review)return;for(const row of review.rows){const item=localCatalog.items[row.itemId];const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v));row.priceCents=variant?.priceCents||item.priceCents;}const total=review.rows.filter(r=>r.included).reduce((n,r)=>n+r.priceCents*r.quantity,0);review.rows.forEach((r,i)=>{const el=reviewDialog.querySelector('[data-wl-row-price="'+i+'"]');if(el)el.textContent=money(r.priceCents);});reviewDialog.querySelector('#review-subtotal').textContent=money(total);reviewDialog.querySelector('.confirm-add').disabled=pending||review.uncertain||!validateReview(review,localCatalog).ok;reviewDialog.querySelector('#review-error').textContent='';}
 async function confirmAdd(){
  if(pending||!review||review.uncertain||unresolved)return;const result=validateReview(review,localCatalog);const error=reviewDialog.querySelector('#review-error');if(!result.ok){error.textContent=[...new Set(result.errors)].join(' ');return;}
  pending=true;reviewDialog.querySelectorAll('button,select,input').forEach(el=>el.disabled=true);error.textContent='Confirming current prices and availability…';
  try{
   await refresh(review.rows.filter(r=>r.included).map(r=>r.itemId));
   const checked=validateReview(review,localCatalog);if(!checked.ok){pending=false;renderReview();errorAfterRender(checked.errors.join(' '));return;}
   const added=await addReviewedLook({request,root:rootPath,attempt:review.requestId,lines:checked.lines,persist:value=>{unresolved=value;try{sessionStorage.setItem('turtleson-wl-pending',JSON.stringify(value))}catch{}}});
   if(added.status==='complete'){unresolved=null;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{};pending=false;closeReview();notify(`${checked.lines.reduce((n,l)=>n+l.quantity,0)} pieces added to your cart.`);refreshCart(added.cart);}
   else if(added.status==='rejected'){unresolved=null;pending=false;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{}renderReview();errorAfterRender(added.message);}
   else{pending=false;review.uncertain=true;renderReview();errorAfterRender(added.status==='partial'?'Some pieces were added. Review your cart before adding the remaining pieces.':'We could not confirm the full addition. Check your cart before trying again.');refreshCart(added.cart,false);}
  }catch(e){pending=false;renderReview();errorAfterRender(e.message || 'Please check your connection and try again.');}finally{if(!pending&&queuedState){const next=queuedState;queuedState=null;showState(next.color,next.look);}}
 }
 function errorAfterRender(message){reviewDialog.querySelector('#review-error').textContent=message;}
 function showRecovery(){returnFocus=document.activeElement;reviewDialog.innerHTML=`<div class="dialog-heading"><h2 id="review-title">Check your cart.</h2><button class="round close-recovery" aria-label="Close cart review">×</button></div><p class="review-intro">Your earlier addition needs a quick review. Check which pieces are already in your cart before adding anything else.</p><a class="primary" href="${rootPath}cart">View my cart ↗</a><p class="review-intro"><label><input type="checkbox" class="checked-cart"> I’ve reviewed the pieces in my cart.</label></p><button class="primary resume-styling" disabled>Continue styling →</button><p class="form-error" role="alert"></p>`;reviewDialog.querySelector('.close-recovery').onclick=closeReview;const checkbox=reviewDialog.querySelector('.checked-cart'),button=reviewDialog.querySelector('.resume-styling');checkbox.onchange=()=>button.disabled=!checkbox.checked;button.onclick=async()=>{button.disabled=true;try{await request(rootPath+'cart.js');unresolved=null;sessionStorage.removeItem('turtleson-wl-pending');closeReview();}catch{reviewDialog.querySelector('.form-error').textContent='Your cart could not be reached. Please try again when your connection returns.';button.disabled=false;}};reviewDialog.showModal();}
 function refreshCart(cart,open=true){document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));if(cart)document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);if(open)setTimeout(()=>{const trigger=document.querySelector('a[aria-label="Open cart modal"]');if(trigger)trigger.click();else location.assign(rootPath+'cart');},350);}
 reviewDialog.addEventListener('cancel',event=>{if(pending)event.preventDefault()});reviewDialog.addEventListener('close',()=>{if(pending)return;review=null;if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});else ui.querySelector('.look-buy')?.focus({preventScroll:true});});
 reviewDialog.addEventListener('click',e=>{if(e.target===reviewDialog){const rect=reviewDialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)closeReview();}});
 await refresh(Object.keys(localCatalog.items).filter(id=>localCatalog.items[id].ownership==='turtleson'));
 const query=new URL(location.href).searchParams;const color=landing?(localCatalog.products["woolen-fleece-quarter-zip"].colors.includes(query.get('color'))?query.get('color'):"Eucalyptus Heather"):selectedColor();showState(color,query.get('look'));
 if(!landing){const check=()=>{const color=selectedColor();if(color!==state?.color)showState(color);};document.addEventListener('change',()=>setTimeout(check,0),{capture:true,signal:lifetime.signal});document.addEventListener('click',event=>{if(event.target.closest('.product__color-swatch'))setTimeout(check,80);},{signal:lifetime.signal});document.addEventListener('product:variant-change',()=>setTimeout(check,0),{signal:lifetime.signal});const target=document.querySelector('[data-section-type="product"][data-product-handle="woolen-fleece-quarter-zip"]');if(target){observer=new MutationObserver(check);observer.observe(target,{subtree:true,attributes:true,attributeFilter:['class']});}}
 else window.addEventListener('popstate',()=>{const q=new URL(location.href).searchParams;showState(localCatalog.products["woolen-fleece-quarter-zip"].colors.includes(q.get('color'))?q.get('color'):"Eucalyptus Heather",q.get('look'));},{signal:lifetime.signal});
 try{if(unresolved){const current=await request(rootPath+'cart.js');if(attemptStatus(current,unresolved.attempt,unresolved.lines)==='complete'){sessionStorage.removeItem('turtleson-wl-pending');unresolved=null;}else notify('An earlier addition needs review. Check your cart before adding another look.');}}catch{}
}
function initializeAll(){document.querySelectorAll('[data-wardrobe-logic]').forEach(host=>initialize(host).catch(()=>{host.querySelector('[data-wl-studio]').innerHTML='<p>Wardrobe Logic is temporarily unavailable. Please refresh the page.</p>';}));}
window.TurtlesonWardrobeLogic={initializeAll};
initializeAll();document.addEventListener('shopify:section:load',initializeAll);

document.addEventListener('shopify:section:unload',event=>{for(const [host,dispose] of controllers)if(event.target.contains(host)){dispose();controllers.delete(host);}});

})();
